import { useState, useContext } from 'react';
import { askChoiceLink } from '../api/askAI.js';
import AuthContext from '../context/AuthContext';

export function useAskAI() {
  const { authFetch } = useContext(AuthContext);
  const [isAskingAI, setIsAskingAI] = useState(false);
  const [popupValue, setPopupValue] = useState('');

  const askAI = async (linkedNodes) => {
    if (linkedNodes.length !== 2) return;

    setIsAskingAI(true);
    try {
      const data = await askChoiceLink(authFetch, linkedNodes);
      setPopupValue(data.link);
    } finally {
      setIsAskingAI(false);
    }
  };
  return {
    askAI,
    isAskingAI,
    popupValue,
    setPopupValue,
  };
}
